import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import appSelectors from '@/redux/app/appSelectors';

// Запрет скролла при открытии меню/модалки
const useBlockScroll = () => {
  const displayLoader = useSelector(appSelectors.displayLoader);
  const displayMenu = useSelector(appSelectors.displayMenu);
  const displayModal = useSelector(appSelectors.displayModal);

  useEffect(() => {
    if (displayMenu || displayLoader || displayModal) {
      document.body.style.overflow = 'hidden';

      // document.body.style.top = `-${window.scrollY}px`;
      // document.body.style.position = 'fixed';
    } else {
      document.body.style.overflow = 'unset';

      // const scrolly = document.body.style.top;
      // document.body.style.position = '';
      // document.body.style.top = '';
      // window.scrollTo(0, Number.parseInt(scrolly || '0', 10) * -1);
    }
  }, [displayLoader, displayMenu, displayModal]);
};

export default useBlockScroll;
